/// Menu
import React, {
  Component,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";
import { Modal } from "react-bootstrap";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from "react-bootstrap/Collapse";
import Button from "react-bootstrap/Button";
import { btnConnect } from "../../../dataBaseFile/alert";
/// Link
import { NavMenuToggle, NavMenuToggleAuto } from "./NavHader";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import PrimaryButton from "../../components/button/primaryButton";
import FeedbackModal from "../../components/feedback/feedback";
import feedbackImg from "../../../media/images/illustration.svg";
import ResponceToaster from "../../components/responceToaster/responceToaster";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import logo from "../../../icons/photos/chillLogo.png";
import appleImg from "../../../icons/chilllIcons/2.png"
import googleImg from "../../../icons/chilllIcons/1.png"
import SendVideoLink from "../../../pages/sendVideoLink/sendVideoLink";
import { btnAdmin, btnConnectToPro, btnDrawing, btnHome, btnJobs, btnObjectRecognition, btnOCR, txtMyRequests, txtProfile, txtTipsTricks } from "../../../dataBaseFile/label";
import { setUserProfileTab } from "../../../feature/userData/userData";
const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    sidebarMenuRole,
    role,
    permissionArr = [],
    companyId,
    isFreeTrialSubscription,
    activeSubscriptionEndTime,
    subscriptionType,
    subscriptionPaidStatus,
    totalCreditsInCents,
    proOptionFlag,
  } = useSelector((state) => state.user) ?? {};

  const { totalEarned } = useSelector((state) => state.finance) ?? {};
  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);
  const [subscriptionTimeLeft, setSubscriptionTimeLeft] = useState(0);
  const [subscriptionString, setSubscriptionString] = useState("");
  const tabPermission =
    (Array.isArray(permissionArr) && permissionArr[0]) || [];
  const TabsArr = [
    {
      title: btnHome,
      classsChange: "mm-collapse",
      iconStyle: "bi bi-house-door",
      to: "/dashboard",
      allowed: tabPermission.includes("HOME TAB"),
    },
    {
      title: `Local services`,
      classsChange: "mm-collapse",
      iconStyle: "bi bi-person-gear",
      to: "/localProDashboard",
      allowed: tabPermission.includes("UPDATE WORK INFORMATION") && proOptionFlag == 4,
    },

    {
      title: btnAdmin,
      classsChange: "mm-collapse",
      iconStyle: "bi bi-person-circle",
      to: "/admin",
      allowed: tabPermission.includes("ADMIN TAB"),
      content: [
        {
          title: "Manage Users",
          to: "/admin",
          allowed: tabPermission.includes("ADMIN TAB"),
        },
        {
          title: "Manage Companies",
          to: "/admin/registeredCompanies",
          allowed: tabPermission.includes("VIEW REGISTERED COMPANIES LIST"),
        },
        {
          title: "Manage Permissions",
          to: "/admin/permissions",
          allowed: tabPermission.includes("ASSIGN PERMISSION TO ROLE"),
        },
        {
          title: "Manage Feedback",
          to: "/admin/feedbackList",
          allowed: tabPermission.includes("VIEW FEEDBACK LIST"),
        },
        {
          title: "Manage Promocode",
          to: "/admin/promocode",
          allowed: tabPermission.includes("ASSIGN PERMISSION TO ROLE"),
        },
        {
          title: "Manage Services",
          to: "/admin/services",
          allowed: (tabPermission.includes("VIEW COMPANY SERVICE REQUESTS") || tabPermission.includes("VIEW ALL SERVICE REQUESTS")),
        },
        {
          title: "Manage Transactions",
          to: "/admin/transactions",
          allowed: tabPermission.includes("FINANCIAL TAB"),
        },
        {
          title: "Manage Refunds",
          to: "/admin/refunds",
          allowed: tabPermission.includes("VIEW REGISTERED COMPANIES LIST"),
        },
        {
          title: "Affiliate Program",
          to: "/admin/affiliateProgram",
          allowed: tabPermission.includes("VIEW REGISTERED COMPANIES LIST"),
        },
        {
          title: "Guest Logins",
          to: "/admin/guestLogin",
          allowed: tabPermission.includes("ADMIN TAB"),
        },
        // {
        //   title: "Call Recordings",
        //   to: "/admin/callRecordings",
        //   allowed: tabPermission.includes("VIEW REGISTERED COMPANIES LIST"),
        // },
        {
          title: "Send Notifications",
          to: "/admin/sendNotifications",
          allowed: tabPermission.includes("VIEW REGISTERED COMPANIES LIST"),
        },
      ],
    },
    {
      title: `Reporting`,
      classsChange: "mm-collapse",
      iconStyle: "bi bi-bar-chart",
      to: "/reports/userLogs",
      allowed: tabPermission.includes("VIEW REGISTERED COMPANIES LIST"),
      content: [
        {
          title: "Users",
          to: "/reports/userLogs",
          allowed: true,
        },
        {
          title: "Services",
          to: "/reports/serviceLogs",
          allowed: true,
        },
      ],
    },
    {
      title: tabPermission.includes("ASSIGN SERVICE REQUEST") ? 'Create service' : btnConnectToPro,
      classsChange: "mm-collapse",
      iconStyle: "bi bi-fullscreen",
      to: "/scan",
      allowed: (tabPermission.includes("ASSIGN SERVICE REQUEST") && companyId),
    },
    {
      title: btnConnectToPro,
      classsChange: "mm-collapse",
      iconStyle: "bi bi-fullscreen",
      to: "/scanNew",
      allowed: tabPermission.includes("SCAN TAB"),
    },
    {
      title: "Agent link",
      classsChange: "mm-collapse",
      iconStyle: "bi bi-link-45deg",
      to: "/addLinkA",
      allowed: tabPermission.includes("SCAN TAB"),
    },
    // {
    //   title: 'Create project',
    //   classsChange: "mm-collapse",
    //   iconStyle: "bi bi-journal-check",
    //   to: "/DIYproject",
    //   allowed: tabPermission.includes("CREATE PROJECT TAB"),
    // },
    {
      title: tabPermission.includes("VIEW COMPANY USERS") ? 'Manage service' : tabPermission.includes("CONNECT TO PRO") ? 'Projects' : btnJobs,
      classsChange: "mm-collapse",
      iconStyle: "bi bi-tools",
      to: "/serviceRequest",
      allowed: tabPermission.includes("SERVICE REQUEST TAB") || tabPermission.includes("ASSIGN SERVICE REQUEST"),
    },
    // {
    //   title: "My Project",
    //   classsChange: "mm-collapse",
    //   iconStyle: "bi bi-book",
    //   to: "/myDiyProject",
    //   allowed: tabPermission.includes("CREATE PROJECT TAB") || tabPermission.includes("ASSIGN SERVICE REQUEST"),
    // },
    {
      title: txtProfile,
      classsChange: "mm-collapse",
      iconStyle: "bi bi-person",
      to: "/userProfile",
      allowed: tabPermission.includes("PROFILE TAB"),
    },
    {
      title: txtTipsTricks,
      classsChange: "mm-collapse",
      iconStyle: "bi bi-lightning-charge",
      to: "/tipsAndTricks",
      allowed: tabPermission.includes("TIPSANDTRICKS TAB"),
    },
    {
      title: "Home maintenance",
      classsChange: "mm-collapse",
      iconStyle: "bi bi-house-gear",
      to: "/maintenance",
      allowed: tabPermission.includes("SCAN TAB"),
    },



    {
      title: "Transactions",
      classsChange: "mm-collapse",
      iconStyle: "bi bi-credit-card-2-front",
      to: "/transactions",
      allowed: ((tabPermission.includes("UPDATE WORK INFORMATION") && !companyId) || (tabPermission.includes("UPDATE WORK INFORMATION") && companyId && totalEarned > 0) || (role == 4) || tabPermission.includes("SCAN TAB")),
      content: [
        {
          title: "Transactions list",
          to: "/transactions",
          allowed: true,
        },
        // {
        //   title: "Payments",
        //   to: "/payments",
        //   allowed: true,
        // },
        // {
        //   title: "Payouts",
        //   to: "/payouts",
        //   allowed: tabPermission.includes("UPDATE WORK INFORMATION"),
        // },
        {
          title: "Earnings",
          to: "/earnings",
          allowed: ((tabPermission.includes("UPDATE WORK INFORMATION") && !companyId) || (tabPermission.includes("UPDATE WORK INFORMATION") && companyId && totalEarned > 0) || (role == 4)),
        },
      ],
    },
    {
      title: ((tabPermission.includes("VIEW COMPANY USERS")) || ((tabPermission.includes("UPDATE WORK INFORMATION") && companyId))) ? "Company details" : "Join company",
      classsChange: "mm-collapse",
      iconStyle: "bi bi-building-add",
      to: "/companyManagement",
      allowed: ((tabPermission.includes("UPDATE WORK INFORMATION")) || (tabPermission.includes("VIEW COMPANY USERS"))),
    },

    {
      title: "Company invitations",
      classsChange: "mm-collapse",
      iconStyle: "bi bi-people",
      to: "/companyRequests",
      allowed: ((tabPermission.includes("UPDATE WORK INFORMATION") && !companyId)),
    },
    // {
    //   title: "NEw Demo",
    //   classsChange: "mm-collapse",
    //   iconStyle: "bi bi-people",
    //   to: "/newDemo",
    //   allowed: true,
    // },
    {
      title: "Playground",
      classsChange: "mm-collapse",
      iconStyle: "bi bi-bag-plus-fill",
      to: "/ocrDemo",
      allowed: tabPermission.includes("PLAYGROUND TAB"),
      content: [
        {
          // title: btnOCR,
          title: 'Capture Text',
          to: "/ocrDemo",
          allowed: true,
        },
        {
          title: btnObjectRecognition,
          to: "/recognizeDemo",
          allowed: true,
        },
        {
          title: btnDrawing,
          to: "/drawingDemo",
          allowed: true,
        },




      ],
    },



  ];
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [state, setState] = useReducer(reducer, initialState);
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [handleToaster, setHandleToaster] = useState(false);
  const [active, setActive] = useState("dashboard");
  const [activeSubmenu, setActiveSubmenu] = useState("");
  const [openSendVideoLinkModal, setOpenSendVideoLinkModal] = useState(false);
  // const handleMenuActive = (status) => {
  //   //alert(1);
  //   setActive(status);
  //   if (active === status) {
  //     setActive("");
  //   }
  // };

  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const hideAppDownloadPromo =
    pathSegments.includes("addLinkA") || pathSegments.includes("addLinkB");

  // Set the active menu and submenus on page load
  useEffect(() => {
    const currentPath = location.pathname || "/";

    let matched = false;

    for (const menu of TabsArr) {
      // main tab match
      if (menu.to === currentPath) {
        setActive(menu.title);
        setActiveSubmenu("");
        matched = true;
        // break;
      }

      // submenu match
      if (Array.isArray(menu.content) && menu.content.length > 0) {
        const foundSubmenu = menu.content.find(sub => sub.to === currentPath);
        if (foundSubmenu) {
          setActive(menu.title);
          setActiveSubmenu(foundSubmenu.title);
          matched = true;
          break;
        }
      }
    }

    // default/fallback -> Home
    if (!matched || currentPath === "/") {
      const homeTitle =
        TabsArr.find(m => m.title?.toLowerCase() === "home")?.title || "Home";
      setActive(homeTitle);
      setActiveSubmenu("");
    }
  }, [location.pathname]);

  // New code for highlight submenu
  const handleMenuActive = (menu) => {
    setActive(menu.title);

    // If the menu has submenus, automatically set the first allowed submenu as active
    if (menu.content && menu.content.length > 0) {
      const firstAllowedSubmenu = menu.content.find((item) => item.allowed);
      if (firstAllowedSubmenu) {
        setActiveSubmenu(firstAllowedSubmenu.title);
        navigate(firstAllowedSubmenu.to);
      }
    }
  };

  // useEffect(() => { console.log(activeSubmenu, "activeSubmenu") }, [activeSubmenu])


  // const handleSubmenuActive = (status) => {
  //   //alert(1);
  //   setActiveSubmenu(status);
  //   if (activeSubmenu === status) {
  //     setActiveSubmenu("");
  //   }
  // };

  // New submenu code
  const handleSubmenuActive = (submenu) => {
    setActiveSubmenu(submenu.title);
    // console.log(submenu.title, "submenu.title")
  };


  let handleheartBlast = document.querySelector(".heart");
  function heartBlast() {
    return handleheartBlast.classList.toggle("heart-blast");
  }

  useEffect(() => { }, []);
  //For scroll
  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const handleDashboard = () => {
    navigate("/dashboard");
  };

  // const handleMenuActive = (status) => {
  //   setState({ active: status });
  //   //console.log(state.active);
  //   if (state.active === status) {
  //     //setActive('');
  //     setState({ active: "" });
  //   }
  // };
  // const handleSubmenuActive = (status) => {
  //   setState({ activeSubmenu: status });
  //   if (state.activeSubmenu === status) {
  //     setState({ activeSubmenu: "" });
  //   }
  //   //status.preventDefault();
  // };
  // Menu dropdown list End

  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  /// Active menu

  function handleFeedbackModal(type, message) {
    setFeedbackMessage(message);
    setFeedbackModal(false);
    setHandleToaster(true);
    setTimeout(() => {
      setHandleToaster(false);
    }, 11000);
  }

  function handleProfile() {
    navigate("/userProfile");
  }
  const currentYear = new Date().getFullYear();

  const getSubscriptionDaysLeft = (unixEndDate) => {
    const currentDate = new Date().getTime(); // Get current date in UNIX timestamp (milliseconds)
    const subscriptionEndDate = unixEndDate * 1000; // Convert UNIX timestamp from seconds to milliseconds

    // Calculate the difference in time (milliseconds)
    const timeDiff = subscriptionEndDate - currentDate;

    // Convert time difference from milliseconds to days
    // const daysLeft = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));


    if (daysLeft >= 0) {
      setSubscriptionTimeLeft(daysLeft);
    }

    if (daysLeft > 0) {
      return `You have ${daysLeft} day(s) left in your subscription.`;
    } else if (daysLeft === 0) {
      return "Your subscription ends today.";
    } else {
      return "Buy subscription";
    }
  }


  useEffect(() => {
    setSubscriptionString(getSubscriptionDaysLeft(activeSubscriptionEndTime));
  }, [activeSubscriptionEndTime]);

  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return (
    <div
      className={`dlabnav border-1 border-end  ${iconHover} ${sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
        ? hideOnScroll > 120
          ? "fixed"
          : ""
        : ""
        }`}
      style={{
        // backgroundColor:'rgba(199, 212, 234, 1)',
        // borderRight: '1px solid rgba(199, 212, 234, 1)',
      }}
    >
      <PerfectScrollbar className="dlabnav-scroll d-flex flex-column">
        <div className="row">
          <div className="row d-flex justify-content-center align-items-center my-4 ">
            <img
              onClick={handleDashboard}
              src={logo}
              style={{ width: "115px", cursor: "pointer" }}
              alt=""
            />
          </div>

          <div className="row">
            <ul className="metismenu fs-5" id="menu" >
              {TabsArr.map((data, index) => {
                if (data.allowed) {
                  let menuClass = data.classsChange;

                  return (
                    <li


                      className={` ${active === data.title ? "mm-active" : ""}`}
                      key={index} >
                      <NavLink
                        to={data.to}
                        className={` ${(activeSubmenu === data.title ? "mm-active" : "",
                          data.content && data.content.length > 0
                            ? "has-arrow"
                            : "")
                          } `}
                        onClick={() => {

                          if (!data.content) {
                            NavMenuToggleAuto()
                          }

                          // handleMenuActive(data.title)
                          handleMenuActive(data)
                        }}

                      >
                        <i
                          className={data.iconStyle}
                          // style={{ color: active === data.title ? "" : "nav-text" }}
                          style={{ color: "black" }}></i>
                        <span className="nav-text text-black text-hovered" style={{ color: "" }}>
                          {data.title}
                        </span>
                      </NavLink>

                      {data?.content && (
                        <Collapse in={active === data.title ? true : false}>
                          <ul
                            className={`${menuClass === "mm-collapse" ? "mm-show" : ""
                              }`}>
                            {data.content &&
                              data.content.map((data, index) => {
                                return (
                                  data.allowed && (
                                    <>
                                      <li
                                        key={index}
                                        className={`${activeSubmenu === data.title
                                          ? "mm-active font-w600"
                                          : ""
                                          }`}>
                                        {data.content &&
                                          data.content.length > 0 ? (
                                          <Link
                                            to={data.to}
                                            className={
                                              data.hasMenu ? "has-arrow" : ""
                                            }
                                            onClick={() => {
                                              NavMenuToggleAuto()
                                              handleSubmenuActive(data);
                                            }}>
                                            {data.title}
                                          </Link>
                                        ) : (
                                          <Link onClick={() => {
                                            NavMenuToggleAuto()
                                            handleSubmenuActive(data);
                                          }} to={data.to}
                                            className={`${activeSubmenu === data.title ? 'text-primary' : ''}`}
                                          >{data.title}</Link>
                                        )}
                                        <Collapse
                                          in={
                                            // activeSubmenu === data.title
                                            //   ? true
                                            //   : false
                                            false
                                          }>
                                          <ul
                                            className={`${menuClass === "mm-collapse"
                                              ? "mm-show"
                                              : ""
                                              }`}
                                          >
                                            {data.content &&
                                              data.content.map(
                                                (data, index) => {
                                                  return (
                                                    <>
                                                      <li key={index}>
                                                        <Link
                                                          className={`${path === data.to
                                                            ? "mm-active"
                                                            : ""
                                                            }`}
                                                          to={data.to}>
                                                          {data.title}
                                                        </Link>
                                                      </li>
                                                    </>
                                                  );
                                                }
                                              )}
                                          </ul>
                                        </Collapse>
                                      </li>
                                    </>
                                  )
                                );
                              })}
                          </ul>
                        </Collapse>
                      )}
                    </li>
                  );
                }
              })}
            </ul>
          </div>

          {(tabPermission.includes("SEND VIDEO LINK") || tabPermission.includes("ASSIGN SERVICE REQUEST")) &&
            <div className="row mt-3">
              {/* <span className="d-flex justify-content-center align-items-center">
                <span
                  className="d-flex pointer"
                  style={{
                    // background: "rgba(86, 86, 86, 1)",
                    padding: "7px",
                    borderRadius: "33px",
                    maxWidth: "167px",
                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                    boxshadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                    border: '2px solid rgba(255, 154, 32, 1)'
                  }}
                  onClick={() => {
                    // setOpenSendVideoLinkModal(true)
                    handleDashboard();
                  }}>
                  <span
                    style={{
                      borderRadius: "100%",
                      height: "43px",
                      width: "72px",
                      background: "white",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}>
                    <i class="bi bi-people-fill" style={{ fontSize: "30px" }}></i>
                  </span>
                  &nbsp;&nbsp;&nbsp;
                  <span
                    className="fs-6"
                    style={{
                      color: "white",
                      display: "flex",
                      justifyContent: "center",
                    }}>
                    {" "}
                    Connect to Customer
                  </span>
                </span>
              </span> */}

              <div className="d-flex justify-content-center align-items-center px-3">
                <Button
                  className="d-flex justify-content-center align-items-center"
                  onClick={() => {
                    if (tabPermission.includes("ASSIGN SERVICE REQUEST")) {
                      setOpenSendVideoLinkModal(true)
                    } else if (tabPermission.includes("SEND VIDEO LINK")) {
                      handleDashboard();
                    }
                  }}
                  style={{
                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                    border: '2px solid rgba(255, 154, 32, 1)',
                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                  }}
                >
                  <i class="bi bi-people fs-2" ></i>
                  {`CONNECT TO CUSTOMER`}
                </Button>
              </div>



            </div>

          }
        </div>

        <div className="row" style={{ flex: '1' }}>
          <div className="col-1">

          </div>
          <div className="col-11 d-flex align-items-end">
            <div className="row" style={{ height: 'fit-content', alignItems: 'end' }}>




              <div className="row d-flex align-items-center mt-2">

                {(tabPermission.includes("SCAN TAB")) &&
                  <>
                    {/* <OverlayTrigger placement="bottom" overlay={upgradeSubscription}> */}
                    <div
                      className="font-w500 my-3 susbscription-banner-side-bar"
                      style={{
                        // display: "flex",
                        // alignItems: "center",
                        // justifyContent: "center",
                        position: "relative",
                      }}
                    >
                      <span
                        className="fs-7 px-3 py-1 text-white font-w700 rounded-3 position-relative"
                        style={{
                          background: "rgba(79, 93, 116, 1)",
                        }}>
                        <span>{`Available credits: `}</span>
                        <span className='font-w600'>{`${USDollar.format(totalCreditsInCents / 100)}`}</span>
                        {/* <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger fs-7 border border-2 border-white">
                          {`${subscriptionTimeLeft}`}
                        </span> */}
                      </span>
                    </div>
                    {/* </OverlayTrigger> */}
                  </>
                }

                {((tabPermission.includes("UPDATE WORK INFORMATION") && !companyId) || (role == 4)) && (tabPermission.includes("SUBSCRIPTION ENABLE")) &&
                  <>
                    {/* <OverlayTrigger placement="bottom" overlay={upgradeSubscription}> */}
                    <div
                      className="font-w500 cursor-pointer my-3 susbscription-banner-side-bar"
                      style={{
                        // display: "flex",
                        // alignItems: "center",
                        // justifyContent: "center",
                        position: "relative",
                      }}
                      onClick={() => {
                        navigate('/userProfile')
                        dispatch(setUserProfileTab(5))
                      }}
                    >
                      <span
                        className="fs-7 px-3 py-1 text-white font-w700 rounded-3 position-relative"
                        style={{
                          background: "rgba(79, 93, 116, 1)",
                        }}>
                        {subscriptionTimeLeft > 0 ?
                          <>
                            {isFreeTrialSubscription ? `Free trial ends in ${subscriptionTimeLeft} day(s)` : (subscriptionType === "Paid" && subscriptionPaidStatus === "active") ? `Subscription renews in ${subscriptionTimeLeft} day(s)` : `Subscription ends in ${subscriptionTimeLeft} day(s)`}
                          </> :
                          `Upgrade`
                        }
                        {/* <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger fs-7 border border-2 border-white">
                          {`${subscriptionTimeLeft}`}
                        </span> */}
                      </span>
                    </div>
                    {/* </OverlayTrigger> */}
                  </>
                }


                {!hideAppDownloadPromo && (
                  <>
                    <span className="mb-1 font-w500 mb-2">{`Download Chilll app`}</span>

                    <a href="https://play.google.com/store/apps/details?id=com.chilll.app" target="_blank" rel="noreferrer">
                      <img src={googleImg} className="mb-2" style={{ width: "150px", height: '45px', cursor: "pointer" }} alt="" />
                    </a>

                    <a href="https://apps.apple.com/us/app/apple-store/id1621747291" target="_blank" rel="noreferrer">
                      <img src={appleImg} style={{ width: "150px", height: '45px', cursor: "pointer" }} alt="" />
                    </a>
                  </>
                )}


              </div>

              <div className="row align-items-center mt-4">
                <a className="text-hovered" href="https://chilll.com/contact/" target="_blank" rel="noreferrer">
                  <span className=" fs-6" style={{ color: '', fontWeight: '600' }}>Contact us</span>
                </a>
              </div>
              <div className="row align-items-center mt-2">
                <a className="text-hovered" href="https://chilll.com/chilll-terms-conditions/" target="_blank" rel="noreferrer">
                  <span className=" fs-6" style={{ color: '', fontWeight: '600' }}>Terms of Service</span>
                </a>
              </div>
              <div className="row  align-items-center mt-2">
                <a className="text-hovered" href="https://chilll.com/privacy-policy/" target="_blank" rel="noreferrer">
                  <span className=" fs-6" style={{ color: '', fontWeight: '600' }}> Privacy Policy</span>
                </a>
              </div>
              <div className="row  align-items-center my-3">
                <a href="https://chilll.com/copyright/" target="_blank" rel="noreferrer">
                  <span className=" d-flex  align-items-center fs-7" >&#x24B8;&nbsp;&nbsp;&nbsp;Chilll, {currentYear}</span>
                </a>
              </div>



            </div>
          </div>



        </div>
        {feedbackModal && (
          <FeedbackModal
            addUserTrigger={feedbackModal}
            handleCloseAddUser={handleFeedbackModal}
          />
        )}

        <Modal
          className="fade"
          centered
          show={openSendVideoLinkModal}
        // onHide={handleCloseChangePassword}
        >
          {/* <Modal.Header style={{ borderBottom: "none" }}>
            <Button
              variant=""
              className="btn-close btn-close-password"
              onClick={() => { setOpenSendVideoLinkModal(false) }}
            ></Button>
          </Modal.Header> */}
          <Modal.Body className="">
            <div className="row mx-0">
              <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black mb-2">
                <span
                  onClick={() => setOpenSendVideoLinkModal(false)}
                  className="cursor-pointer text-hovered">
                  <i className="bi bi-x-lg"></i>
                </span>
              </div>
            </div>
            <SendVideoLink />
          </Modal.Body>
        </Modal>
        {handleToaster && (
          <ResponceToaster toasterType={"success"} message={feedbackMessage} />
        )}
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
